import { http } from '../../config/axios'

export default function ativarPlano(idPlano: string): Promise<string> {
  return http
    .patch('api/plano/ativar/' + idPlano)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro ativarPlano', error)
      throw Error(error.response.data)
    })
}
